<template>
  <MultipleSelector>
    <SelectorSlide
      v-for="month in availableMonths"
      :key="month"
      :valueKey="month"
      :is-selected="selectedMonths.includes(month)"
      @toggle="toggleMonth"
    >
      {{ formattedMonth(month) }}
    </SelectorSlide>
  </MultipleSelector>
</template>

<script>
import MultipleSelector from "../UI/MultipleSelector.vue";
import SelectorSlide from "../UI/SelectorSlide.vue";

export default {
  name: "MonthSelector",
  emits: ["toggle-month"],
  components: {
    MultipleSelector,
    SelectorSlide,
  },
  props: {
    availableMonths: {
      type: Array,
      required: true,
    },
    selectedMonths: {
      type: Array,
      required: true,
    },
  },
  methods: {
    formattedMonth(month) {
      const [year, monthNum] = month.split('-');
      const shortYear = year.slice(-2);
      return `${monthNum}/${shortYear}`;
    },
    toggleMonth(month) {
      this.$emit("toggle-month", month);
    },
  },
};
</script>

<style scoped lang="scss"></style>
